module.exports = __webpack_public_path__ + "static/media/signature_placeholder.0ea1c896.png";